export default __webpack_public_path__ + "static/media/link-1.1217f161.svg";